import { ReactElement, ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Row } from "@/libraries/wpl/foundations/src";

import { ButtonProps } from "../../components/button/src/button";
import { wacToken } from "../../foundations";

const ctaStyles = css({
    maxWidth: "1440px",
    margin: `${token("space.200")} auto`,

    textAlign: "center"
});

const typographyOverrides = css({
    marginBlock: `${token("space.0")} !important`
});

const polygonStyles = css({
    background: "var(--background-color)",
    clipPath:
        "polygon(1.5% 0, 70% 3%, 70% 13%, 97% 9%, 97.5% 89%, 40% 100%, 39.9% 90%, 1% 88%)",
    [media.below.sm]: {
        clipPath: "polygon(0 0, 100% 4%, 100% 97%, 28% 100%, 28% 87%, 0 87%)"
    },
    padding: `${token("space.1000")} 0`
});

const contentStyles = css({
    display: "grid",
    gap: token("space.100"),
    marginBlockEnd: token("space.400")
});

export type CtaWithPolygonBackgroundProps = {
    header: ReactNode | string;
    paragraph?: ReactNode | string;
    button: ReactElement<ButtonProps> | ReactNode;
    backgroundColor?: "black" | "blue";
};

export const CtaWithPolygonBackground = ({
    header,
    paragraph,
    button,
    backgroundColor = "black"
}: CtaWithPolygonBackgroundProps) => {
    return (
        <section css={ctaStyles}>
            <div
                style={
                    {
                        "--background-color": wacToken(
                            `color.primary.${backgroundColor}`
                        )
                    } as React.CSSProperties
                }
                css={polygonStyles}
            >
                <Row layout="8">
                    <div css={contentStyles}>
                        <h2
                            className="h3"
                            css={typographyOverrides}
                            style={{ color: wacToken("color.neutral.light0") }}
                        >
                            {header}
                        </h2>
                        {paragraph && (
                            <p
                                className=".body-md"
                                css={typographyOverrides}
                                style={{
                                    color: wacToken("color.neutral.light0")
                                }}
                            >
                                {paragraph}
                            </p>
                        )}
                    </div>
                </Row>
                {button}
            </div>
        </section>
    );
};
